module.exports = __webpack_public_path__ + "static/media/exclamation.932b5506.svg";